module.exports = __webpack_public_path__ + "img/payslip-empty-image.bf5492bc.png";